import React from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { deleteMarketingActivities } from "../../../api_calls/marketingActivities";
import { deleteItems } from "../../../Store/actions";
import ConfirmationPopup from "../../../components/commonComponents/ConfirmationPopup";
import CommonConfirmation from "../../../components/commonComponents/CommonConfirmation";

const DeleteActivity = (props) => {
  const dispatchAction = useDispatch();

  // to reset the pre-selected data or any new information added by user (when popup is closed)
  const reset_data = () => {
    // reset in redux state also
    dispatchAction(deleteItems(["activity_ids_to_delete"]));
  };

  const deleteRecords = async () => {
    // delete the record
    deleteMarketingActivities().then((info) => {
      if (info.success === true) {
        toast("Marketing activity deleted successfully.", { type: "success" });
      } else {
        toast("Sorry, something went wrong.", { type: "error" });
      }
      reset_data();
      props.closePopup(false);
    });

  };

  return (
    <>
      <CommonConfirmation
        confirmationActionCall={deleteRecords}
        closePopup={props.closePopup}
        confirmTitle="Delete Analytics Product(s)"
        showConfirmationPopup={props.showdeleteActivityPopup}
        confirmationMessage="Are you sure you want to delete the selected Marketing Activity?"
      />
    </>

  );
};

export default DeleteActivity;
